<script>
  import { Router } from 'svelte-router-spa'
  import { routes } from './routes'
  import HeaderBar from './components/HeaderBar.svelte'

  let password = null;
  let pw = (!location.href.includes('localhost')) ? -1268326508 : 46;
  let authenticated = (password && hash(password) === pw) ? true : (localStorage.tic && Number(localStorage.tic) === pw) ? true : false;

  // $: if (password) console.log(`password:`, hash(password));
  $: if (password && hash(password) === pw) {
    localStorage.setItem('tic', hash(password));
    authenticated = true;
  }

  const hash = s =>
    s.split('').reduce((a, b) => {
      a = (a << 5) - a + b.charCodeAt(0)
      
      return a & a
    }, 0)
</script>

<style>
  .duringAuth {
    background: linear-gradient(purple, pink);
    height: 100vh;
  }

  #auth {
    font-family: sans-serif;
    font-size: 12px;
    margin: 0 auto;
    width: 240px;
    margin-top: 40vh;
  }

  #auth div {
    padding: 20px;
    border-radius: 5px;
    background: rgba(0,0,0,0.15);
    color: white;
  }

  label {
    font-weight: bold;
    color: black;
    text-shadow: 0 0 5px #fff;
    font-size: 1.25em;
  }

  input[type='password'] {
    width: 200px;
    height: 2em;
    border-radius: 5px;
    border-color: transparent;
  }
</style>

<main class={authenticated ? '' : 'duringAuth'}>
  <section class="section">
    <div class="container">
      {#if authenticated}
      <HeaderBar />
      <Router {routes} />
      {:else}
      <form id="auth">
        <div>
          <label for="password">Password:</label>
          <input id="password" bind:value={password} type="password" autocomplete="current-password" />
        </div>
      </form>
      {/if}
    </div>
  </section>
</main>
